
import { Component, Inject, Vue } from "vue-property-decorator";
import LoadingOverlay from "../../../../common/src/components/LoadingOverlay.vue";
import sortBy from "lodash.sortby";
import { Container } from "inversify";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";
import NoRecords from "../../../../common/src/components/NoRecords.vue";
import { Action } from "vuex-class-modules";

@Component({
    components: { NoRecords, LoadingOverlay },
})
export default class NewOrganizationList extends Vue {
    @Inject("container") readonly container!: Container;
    organizationListStore: OrganizationListStore = this.container.get(OrganizationListStore);
    pageSize = 10;
    page = 1;

    get pageCount(): number {
        return Math.max(1, Math.ceil(this.organizationListStore.count / this.pageSize));
    }

    @Action
    async changePage(page: number) {
        this.page = page;
    }

    get lastCreatedOrganizations() {
        return sortBy(this.organizationListStore.items, ["createdAt"])
            .reverse()
            .slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    }
}
